import React from "react";
import { Box } from "@mui/material";
import { useDraggable } from "@dnd-kit/core";

interface DraggableCardProps {
  doc: { id: number };
  children: React.ReactNode;
}

export const DraggableCard: React.FC<DraggableCardProps> = ({
  doc,
  children,
}) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `available-${doc.id}`,
    data: { doc },
  });

  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      sx={{
        cursor: "grab",
      }}
    >
      <Box
        sx={{
          visibility: isDragging ? "hidden" : "visible",
          height: isDragging ? 0 : "auto",
          overflow: "hidden",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
